const FIELD_MAPPINGS: Partial<Record<keyof Patient, string>> = {
  addressLine1: 'address',
  city: 'city',
  dateOfBirth: 'date of birth',
  firstName: 'first name',
  lastName: 'last name',
  mrn: 'MRN',
  phoneNumber: 'phone number',
  sex: 'sex assigned at birth',
  state: 'state',
  zip: 'zip',
};

const REQUIRED_FIELDS: Array<keyof Patient> = [
  'firstName',
  'lastName',
  'dateOfBirth',
  'phoneNumber',
  'sex',
  'addressLine1',
  'city',
  'state',
  'zip',
  'mrn',
];

export const getEmptyLabOrderFields = (patient: Patient): string[] => {
  return REQUIRED_FIELDS.filter((field) => !patient?.[field]).map(
    (field) => FIELD_MAPPINGS[field],
  );
};
